import { render, staticRenderFns } from "./comp_CheckoutDeliverySellerBox.vue?vue&type=template&id=650ce0d2&scoped=true"
import script from "./comp_CheckoutDeliverySellerBox.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutDeliverySellerBox.vue?vue&type=script&lang=js"
import style0 from "./comp_CheckoutDeliverySellerBox.vue?vue&type=style&index=0&id=650ce0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ce0d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRadioGroup,VSpacer})
